export const ROUTE_ROOT = '/';
export const ROUTE_HOME = '/home';
export const POST_PAYMENT_PARAM = 'postPayment';
export const ROUTE_DIARY = '/diary';
export const ROUTE_OVERVIEW = '/overview';
export const ROUTE_MAIL = '/mail';
export const ROUTE_PARTNERS = '/partners';
export const ROUTE_SCHOOL_LINKS = '/school-links';
export const ROUTE_SUBSCRIPTION = '/subscription';
export const SUB_ROUTE_SUBSCRIPTION_PAYMENT_OPTIONS = '/payment-options';
export const ROUTE_SUBSCRIPTION_PAYMENT_OPTIONS = `${ROUTE_SUBSCRIPTION}${SUB_ROUTE_SUBSCRIPTION_PAYMENT_OPTIONS}`;
export const SUB_ROUTE_SUBSCRIPTION_CHECKOUT = '/checkout';
export const ROUTE_SUBSCRIPTION_CHECKOUT = `${ROUTE_SUBSCRIPTION}${SUB_ROUTE_SUBSCRIPTION_CHECKOUT}`;
export const ROUTE_SUPPORT = '/faq';
export const ROUTE_OTHER = '/other';
export const SUB_ROUTE_OTHER_THEME = '/theme';
export const ROUTE_OTHER_THEME = `${ROUTE_OTHER}${SUB_ROUTE_OTHER_THEME}`;
export const ROUTE_TERMS_AND_CONDITIONS = '/terms-and-conditions';
export const ROUTE_STUDENT_JOIN_OFFERS = '/student-join-offers';
export const ROUTE_PROFILE_SELECTION = '/profile-selection';
export const SUB_ROUTE_PROFILE_FAQ = '/profile-faq';
export const ROUTE_PROFILE_FAQ = `${ROUTE_PROFILE_SELECTION}${SUB_ROUTE_PROFILE_FAQ}`;
export const SUB_ROUTE_DETAILED_NEWS = '/detailed-news';
export const ROUTE_DETAILED_NEWS = `${ROUTE_HOME}${SUB_ROUTE_DETAILED_NEWS}`;
